// extracted by mini-css-extract-plugin
export default {"text":"src-signer-app-signer-signature-document-signed-data-modal-module__text--HeRWv"};